export default __webpack_public_path__ + "static/modern-resume-783721729922a31c153f27b3ead1c053.png";